export default __webpack_public_path__ + "static/media/gas.9b829454.svg";